const has_image = item => typeof item?.image === 'string' && item.image.trim().length > 0

/** An explicit source marker keeps a linked default distinct from an author's own state image. */
export const isNovelCharacterCardState = state => state?.image_source === 'character_card'

/** Project mutable authoring content only. Frozen versions and runs must keep their saved states. */
export function withNovelCharacterCardStates(pack) {
  if (!Array.isArray(pack?.characters)) return pack
  let changed = false
  const characters = pack.characters.map(person => {
    if (!person || typeof person !== 'object' || Array.isArray(person) || person.id === pack.player_id) return person
    if (person.performance_states !== undefined && !Array.isArray(person.performance_states)) return person
    const original = person.performance_states ?? []
    const pictured = has_image(person)
    let states = original.flatMap(state => {
      if (!isNovelCharacterCardState(state)) return [state]
      const rules = person.drama_presets?.locations
      const referenced = Array.isArray(rules) && rules.some(rule => rule?.state_id === state.id)
      if (!pictured && !referenced) return []
      const image = pictured ? person.image : ''
      return [state.image === image ? state : { ...state, image }]
    })
    if (pictured && !states.some(has_image)) {
      const ids = new Set(states.map(state => state?.id))
      let id = 'character-card'
      for (let suffix = 2; ids.has(id); suffix += 1) id = `character-card-${suffix}`
      // Keep existing draft indexes stable for validation and pending-entry navigation.
      states = [...states, { id, image: person.image, description: '', image_source: 'character_card' }]
    }
    if (states.length === original.length && states.every((state, index) => state === original[index])) return person
    changed = true
    return { ...person, performance_states: states }
  })
  return changed ? { ...pack, characters } : pack
}
